window.addEventListener('load', function () {
  // height
  const heightContent = document.querySelectorAll('.header-window');
  heightContent.forEach((item) => {
    const firstLine = item.getElementsByClassName('header-window-row1');
    const targetContent = item.getElementsByClassName('header-window-row2');
    const height = targetContent[0].scrollHeight;
    firstLine[0].style.transition = 'height 0.4s ease-out';
    firstLine[0].style.height = height + 'px';
  });
});

class HeaderAction {
  constructor() {
    this.searchButton();
    this.buttonAction();
    this.rowSecAction();
    this.rowThiAction();
    this.rowForAction();
    this.closeButton();
  }
  searchButton() {
    const target = document.querySelector('.js-search-button');
    const area = document.querySelector('.js-header-search');
    const overlay = document.querySelector('.search-overlay');
    
    console.log(target);
    console.log(overlay);
    target.addEventListener('click', function() {
      area.classList.add('is-active');
      overlay.classList.add('is-active');
    });
    overlay.addEventListener('click', function() {
      area.classList.remove('is-active');
      overlay.classList.remove('is-active');
      area.classList.add('isnot-active');
    });
  }
  buttonAction() {
    const toggler = document.querySelectorAll('.js-header-button > li');
    toggler.forEach((item) => {
      item.addEventListener('click', buttonClick);
    });
    function buttonClick(e) {
      const target = e.currentTarget;
      const targetWindow = target.querySelector('.header-window');
      const activeWindow = document?.querySelector('.header-window.is-active');
      toggler.forEach((item) => {
        if (!target.classList.contains('is-active')) {
          item.classList.remove('is-active');
        }
      });
      if (!target.classList.contains('is-active')) {
        targetWindow.classList.remove('not-active');
        targetWindow.classList.add('is-active');

        target.classList.add('is-active');
      }
      if (activeWindow) {
        activeWindow.classList.add('not-active');
        activeWindow.classList.remove('is-active');
      }
    }
  }
  rowSecAction() {
    const toggler = document.querySelectorAll('.header-window-row2 > li');
    toggler.forEach((item) => {
      item.addEventListener('mouseover', buttonHover, false);
      item.addEventListener('mouseleave', buttonLeave, false);
    });
    function buttonHover(e) {
      const target = e.currentTarget;
      const targetMenu = target.dataset.row2Item ?? '0';
      const activeWindow = document.querySelector(
        '.is-show.header-window-row3',
      );
      const activeForWindow = document.querySelector(
        '.is-show.header-window-row4',
      );
      const targetWindow = document.querySelector(
        `[data-row3="${targetMenu}"]`,
      );
      const activeThiMenu = document.querySelector(
        '.header-window-row3 li.is-active',
      );
      toggler.forEach((item) => {
        item.classList.remove('is-active');
      });
      target.classList.add('is-active');
      if (targetMenu !== targetWindow?.dataset?.row3) {
        if (activeForWindow) {
          activeForWindow.classList.remove('is-show');
        }
        if (activeWindow) {
          activeWindow.classList.remove('is-show');
          // height
          let height = document.querySelector(
            '.header-window.is-active .header-window-row2',
          )?.scrollHeight;
          document.querySelector(
            '.header-window.is-active .header-window-row1',
          ).style.height = height + 'px';
        }
        if (activeThiMenu) {
          activeThiMenu.classList.remove('is-active');
        }
      }
      if (targetMenu !== '0') {
        if (activeWindow) {
          activeWindow.classList.remove('is-show');
        }
        targetWindow.classList.add('is-show');
        // height
        const heightSec =
          document?.querySelector(
            '.header-window.is-active .header-window-row2',
          )?.scrollHeight ?? 0;
        const heightThi =
          document?.querySelector(
            '.header-window.is-active .header-window-row3.is-show',
          )?.scrollHeight ?? 0;
        const heightFor =
          document?.querySelector(
            '.header-window.is-active .header-window-row4.is-show',
          )?.scrollHeight ?? 0;
        const maxHeight = Math.max(heightSec, heightThi, heightFor);
        document.querySelector(
          '.header-window.is-active .header-window-row1',
        ).style.height = maxHeight + 'px';
      }
    }
    function buttonLeave(e) {
      const target = e.currentTarget;
      if (!target.classList.contains('header-window-listIncMenu')) {
        target.classList.remove('is-active');
      }
    }
  }
  rowThiAction() {
    const toggler = document.querySelectorAll('.header-window-row3 > li');
    toggler.forEach((item) => {
      item.addEventListener('mouseover', buttonHover, false);
      item.addEventListener('mouseleave', buttonLeave, false);
    });
    function buttonHover(e) {
      const target = e.currentTarget;
      const targetMenu = target.dataset.row3Item ?? '0';
      const activeWindow = document.querySelector(
        '.is-show.header-window-row4',
      );
      const targetWindow = document.querySelector(
        `[data-row4="${targetMenu}"]`,
      );
      toggler.forEach((item) => {
        item.classList.remove('is-active');
      });
      target.classList.add('is-active');
      if (targetMenu !== targetWindow?.dataset?.row4) {
        if (activeWindow) {
          activeWindow.classList.remove('is-show');
          // height
          let height = document.querySelector(
            '.header-window.is-active .header-window-row3',
          ).scrollHeight;
          document.querySelector(
            '.header-window.is-active .header-window-row1',
          ).style.height = height + 'px';
        }
      }
      if (targetMenu !== '0') {
        if (activeWindow) {
          activeWindow.classList.remove('is-show');
        }
        targetWindow.classList.add('is-show');
        const heightSec =
          document?.querySelector(
            '.header-window.is-active .header-window-row2',
          )?.scrollHeight ?? 0;
        const heightThi =
          document?.querySelector(
            '.header-window.is-active .header-window-row3.is-show',
          )?.scrollHeight ?? 0;
        const heightFor =
          document?.querySelector(
            '.header-window.is-active .header-window-row4.is-show',
          )?.scrollHeight ?? 0;
        const maxHeight = Math.max(heightSec, heightThi, heightFor);
        document.querySelector(
          '.header-window.is-active .header-window-row1',
        ).style.height = maxHeight + 'px';
      }
    }
    function buttonLeave(e) {
      const target = e.currentTarget;
      if (!target.classList.contains('header-window-listIncMenu')) {
        target.classList.remove('is-active');
      }
    }
  }
  rowForAction() {
    const toggler = document.querySelectorAll('.header-window-row4 > li');
    toggler.forEach((item) => {
      item.addEventListener('mouseover', buttonHover, false);
      item.addEventListener('mouseleave', buttonLeave, false);
    });
    function buttonHover(e) {
      const target = e.currentTarget;
      target.classList.add('is-active');
    }
    function buttonLeave(e) {
      const target = e.currentTarget;
      target.classList.remove('is-active');
    }
  }
  closeButton() {
    const toggler = document.querySelectorAll('.js-header-closeButton');
    toggler.forEach((item) => {
      item.addEventListener('click', buttonClick, false);
    });
    closestClick();

    function closestClick() {
      document.addEventListener('click', (e) => {
        const targetWindow = document.querySelector('.header-window.is-active');
        if (targetWindow) {
          if (!e.target.closest('.header')) {
            buttonClick();
          }
        }
      });
    }
    function buttonClick(e) {
      if (e) {
        e.stopPropagation();
      }
      const targetWindow = document.querySelector('.header-window.is-active');
      const activeWindow4 = document.querySelector(
        '.is-show.header-window-row4',
      );
      const activeWindow3 = document.querySelector(
        '.is-show.header-window-row3',
      );
      const activeToggler = document.querySelector(
        '.js-header-button > li.is-active',
      );

      const styledContent = document.querySelector('.header-window.is-active');
      const targetContent =
        styledContent.getElementsByClassName('header-window-row2');
      const height = targetContent[0].scrollHeight;
      activeToggler.classList.remove('is-active');
      setTimeout(() => {
        styledContent.querySelector('.header-window-row1').style.height =
          height + 'px';
      }, 300);

      targetWindow.classList.remove('is-active');
      targetWindow.classList.add('not-active');
      if (activeWindow4) {
        activeWindow4.classList.remove('is-show');
      }
      if (activeWindow3) {
        activeWindow3.classList.remove('is-show');
      }
    }
  }
}
class Humburgermenu {
  constructor() {
    this.buttonAction();
    // this.rowSecAction();
    // this.rowThiAction();
    // this.rowForAction();
    // this.closeButton();
  }
  buttonAction() {
    // メニュー展開時に背景を固定
    const backgroundFix = (bool) => {
      const scrollingElement = () => {
        const browser = window.navigator.userAgent.toLowerCase();
        if ('scrollingElement' in document) return document.scrollingElement;
        return document.documentElement;
      };

      const scrollY = bool
        ? scrollingElement().scrollTop
        : parseInt(document.body.style.top || '0');

      const fixedStyles = {
        height: '100vh',
        position: 'fixed',
        top: `${scrollY * -1}px`,
        left: '0',
        width: '100%',
      };

      Object.keys(fixedStyles).forEach((key) => {
        document.body.style[key] = bool ? fixedStyles[key] : '';
      });

      if (!bool) {
        window.scrollTo(0, scrollY * -1);
      }
    };

    // 変数定義
    const CLASS = '-active';
    let flg = false;
    let accordionFlg = false;

    let hamburger = document.getElementById('js-humburger');
    let focusTrap = document.getElementById('js-focus-trap');
    let menu = document.querySelector('.js-humburger-area');
    let accordionTrigger = document.querySelectorAll(
      '.js-sp-accordion-trigger',
    );
    let accordion = document.querySelectorAll('.js-sp-accordion');

    // メニュー開閉制御
    hamburger.addEventListener('click', (e) => {

      //ハンバーガーボタンが選択されたら
      e.currentTarget.classList.toggle(CLASS);
      menu.classList.toggle(CLASS);
      if (flg) {
        // flgの状態で制御内容を切り替え
        backgroundFix(false);
        document.querySelector('.header-inner').classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.focus();
        flg = false;
      } else {
        backgroundFix(true);
        document.querySelector('.header-inner').classList.add('is-active');
        hamburger.setAttribute('aria-expanded', 'true');
        flg = true;
      }
    });
    window.addEventListener('keydown', () => {
      //escキー押下でメニューを閉じられるように
      if (event.key === 'Escape') {
        hamburger.classList.remove(CLASS);
        menu.classList.remove(CLASS);

        backgroundFix(false);
        hamburger.focus();
        hamburger.setAttribute('aria-expanded', 'false');
        flg = false;
      }
    });

    // メニュー内アコーディオン制御
    accordionTrigger.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle(CLASS);
        e.currentTarget.nextElementSibling.classList.toggle(CLASS);
        if (accordionFlg) {
          e.currentTarget.setAttribute('aria-expanded', 'false');
          accordionFlg = false;
        } else {
          e.currentTarget.setAttribute('aria-expanded', 'true');
          accordionFlg = true;
        }
      });
    });

    // フォーカストラップ制御
    focusTrap.addEventListener('focus', (e) => {
      hamburger.focus();
    });
  }
}
class Footer {
  constructor () {
    const h = window.innerWidth;
    if(h < 768) {
      this.accordion();
    }
  }
  accordion() {
    // メニューを開く関数
    const slideDown = (el) => {
      el.style.height = 'auto'; //いったんautoに
      let h = el.offsetHeight; //autoにした要素から高さを取得
      el.style.height = h + 'px';
      el.animate([ //高さ0から取得した高さまでのアニメーション
        { height: 0 },
        { height: h + 'px' }
      ], {
        duration: 300, //アニメーションの時間（ms）
      });
    };

    // メニューを閉じる関数
    const slideUp = (el) => {
      el.style.height = 0;
    };

    let activeIndex = null; //開いているアコーディオンのindex

    //アコーディオンコンテナ全てで実行
    const accordions = document.querySelectorAll('.include-accordion');
    
    accordions.forEach((accordion) => {
      //アコーディオンボタン全てで実行
      const accordionBtns = accordion.querySelectorAll('.accordionBtn');
      accordionBtns.forEach((accordionBtn, index) => {
        accordionBtn.addEventListener('click', (e) => {
          e.preventDefault();
          activeIndex = index; //クリックされたボタンを把握
          accordionBtn.classList.toggle('active'); //ボタンの親要素（=ul>li)にクラスを付与／削除
          e.target.parentNode.classList.toggle('active'); //ボタンの親要素（=ul>li)にクラスを付与／削除
          const content = accordionBtn.nextElementSibling; //ボタンの次の要素（=ul>ul）
          if(e.target.parentNode.classList.contains('active')){
            slideDown(content); //クラス名がactive（＝閉じていた）なら上記で定義した開く関数を実行
          }else{
            slideUp(content); //クラス名にactiveがない（＝開いていた）なら上記で定義した閉じる関数を実行
          }
          accordionBtns.forEach((accordionBtn, index) => {
            if (activeIndex !== index) {
              accordionBtn.parentNode.classList.remove('active');
              const openedContent = accordionBtn.nextElementSibling;
              slideUp(openedContent); //現在開いている他のメニューを閉じる
            }
          });
          //スクロール制御のために上位階層ulのクラス名を変える
          let container = accordion.closest('.scroll-control'); //sroll-controlnのクラス名である親要素を取得
          if(accordionBtn.parentNode.classList.contains('active') == false && container !== null ){
            container.classList.remove('active')
          }else if (container !== null){
            container.classList.add('active')
          }
        });
      });
    });
  }
}
class LanguageChip {
  constructor() {    
    function chipFadeIn() {
      gsap.to('.chip--language-select', {
        duration: 0.3,
        autoAlpha: 1,
      });
      chip.classList.add('open');
    }
    function chipFadeOut() {
      gsap.to('.chip--language-select', {
        duration: 0.3,
        autoAlpha: 0,
      });
      chip.classList.remove('open');
    }
    const chip = document.querySelector('.chip--language');
    document.addEventListener('click', (e) => {
      const chipOpen = document.querySelector('.chip--language.open');
      if (e.target.closest('.chip--language')) {
        chipFadeIn()
      } else if (!e.target.closest('.chip--language-select')) {
        chipFadeOut();
      }
    });
  }
}

class Header {
  init() {
    new HeaderAction();
    new Humburgermenu();
    new LanguageChip();
    new Footer();
  }
}
export default Header;
